export const translateJobKey = (key: string) => {
  return key.replace('fullTime', 'Vollzeit').replace('partTime', 'Teilzeit');
};
